import type { NavigationShowMode } from '@lighthouse/core'
import { createContext, useContext } from 'react'

interface AppContainerContextProps {
    appId: string
    scale?: number
    isSticky?: boolean
    height: number
    showMode?: NavigationShowMode
    disabledPageScroll?: boolean
}

const AppContainerContext = createContext<AppContainerContextProps>({ appId: '', height: 0 })

export const AppContainerContextProvider = AppContainerContext.Provider

export const useAppContainerContext = () => useContext(AppContainerContext)
